export function getNextStatus(status) {
  const stati = ['new', 'picked', 'completed'];
  const index = stati.indexOf(status);
  return stati[Math.min(index + 1, stati.length - 1)];
}

export function cbBalanceQty(
  balance,
  case_qty,
  skus,
  shortHand,
  showZero,
  showSkus,
  displaySuffix
) {
  var cases = balanceToCases(balance, case_qty);
  var bottles = balanceToBottles(balance, case_qty);
  return cbQtyText(
    cases,
    bottles,
    skus,
    shortHand,
    showZero,
    showSkus,
    displaySuffix
  );
}

export function cbQtyText(
  cases,
  bottles,
  skus,
  shortHand = true,
  showZero = false,
  showSkus = true,
  displaySuffix = null
) {
  var suffix = displaySuffix || 'c';
  var caseSuffix;
  if (shortHand) {
    caseSuffix = suffix;
  } else {
    if (cases === 1) {
      caseSuffix =
        suffix === 'p' ? ' pallet' : suffix === 'k' ? ' keg' : ' case';
    } else {
      caseSuffix =
        suffix === 'p' ? ' pallets' : suffix === 'k' ? ' kegs' : ' cases';
    }
  }
  var bottleSuffix = shortHand ? 'bt' : bottles === 1 ? ' bottle' : ' bottles';
  var skuSuffix = skus === 1 ? '&nbsp;SKU' : '&nbsp;SKUs';

  var cbText =
    (cases < 0 || bottles < 0 ? '-' : '') +
    (cases !== 0 ? Math.abs(cases) + caseSuffix + ' ' : '') +
    (bottles !== 0 ? Math.abs(bottles) + bottleSuffix : '');

  if (cbText === '' && showZero === true) {
    cbText = cases === 0 ? cases + caseSuffix + ' ' : '';
  }

  if (skus !== 0 && showSkus) {
    if (cbText && cbText !== '') cbText += '<br />' + skus + skuSuffix;
  }

  return cbText.trim();
}

export function cbToBalance(cases, bottles, case_qty) {
  cases = typeof cases === 'string' ? parseInt(cases || '0') : cases;
  bottles = typeof bottles === 'string' ? parseInt(bottles || '0') : bottles;
  return casesToBalance(cases, case_qty) + bottlesToBalance(bottles, case_qty);
}

export function balanceToCases(balance, case_qty) {
  var cases =
    balance < 0
      ? Math.ceil(balance / case_qty)
      : Math.floor(balance / case_qty);
  return cases;
}

export function balanceToBottles(balance, case_qty) {
  var bottles = balance % case_qty;
  return bottles;
}

export function casesToBalance(cases, case_qty) {
  return cases * case_qty;
}

export function bottlesToBalance(bottles, case_qty) {
  return bottles;
}

export function pluralize(count, noun, suffix = 's') {
  if (count === 1) {
    return `${count} ${noun}`;
  }
  return `${count} ${noun}${suffix}`;
}

// Format order quantities grouped by format type (pallets, kegs, cases)
export function formatOrderQtyBySuffix(orderLines, shortHand = true) {
  if (!orderLines || orderLines.length === 0) {
    return '0';
  }

  var qtyBySuffix = { p: { cases: 0 }, k: { cases: 0 }, c: { cases: 0 } };
  var totalBottles = 0;

  orderLines.forEach(function (line) {
    if (!line || !line.offering) return;

    var qty = line.qty || 0;
    var caseQty = line.offering.case_qty || 1;
    var lineCases = Math.floor(qty / caseQty);
    var lineBottles = qty % caseQty;

    var suffix = (
      line.offering.display_suffix ||
      line.offering.displaySuffix ||
      'c'
    ).toLowerCase();
    if (qtyBySuffix[suffix] === undefined) {
      suffix = 'c';
    }

    qtyBySuffix[suffix].cases += lineCases;
    totalBottles += lineBottles;
  });

  return formatQtyBySuffix(qtyBySuffix, totalBottles, shortHand);
}

// Helper to format grouped quantities into display string
function formatQtyBySuffix(qtyBySuffix, totalBottles, shortHand) {
  var parts = [];

  // Add pallets
  if (qtyBySuffix['p'].cases > 0) {
    var palletText =
      qtyBySuffix['p'].cases +
      (shortHand ? 'p' : qtyBySuffix['p'].cases === 1 ? ' pallet' : ' pallets');
    parts.push(palletText);
  }

  // Add kegs
  if (qtyBySuffix['k'].cases > 0) {
    var kegText =
      qtyBySuffix['k'].cases +
      (shortHand ? 'k' : qtyBySuffix['k'].cases === 1 ? ' keg' : ' kegs');
    parts.push(kegText);
  }

  // Add cases
  if (qtyBySuffix['c'].cases > 0) {
    var caseText =
      qtyBySuffix['c'].cases +
      (shortHand ? 'c' : qtyBySuffix['c'].cases === 1 ? ' case' : ' cases');
    parts.push(caseText);
  }

  // Add bottles
  if (totalBottles > 0) {
    var bottleText =
      totalBottles +
      (shortHand ? 'bt' : totalBottles === 1 ? ' bottle' : ' bottles');
    parts.push(bottleText);
  }

  return parts.length > 0 ? parts.join(' ') : '0';
}

export function formatGraphQLError(e) {
  if (e.networkError) {
    return new Error('There was a network error. Please try again.');
  } else if (e.graphQLErrors && e.graphQLErrors.length > 0) {
    const firstError = e.graphQLErrors[0];
    const otherErrors = e.graphQLErrors.slice(1).length;
    if (otherErrors > 0) {
      return new Error(`${firstError.message} and ${otherErrors} more`);
    }
    return new Error(firstError.message);
  } else {
    return new Error(e.message);
  }
}



// WEBPACK FOOTER //
// ./src/utils.js